import { callExternalApi, CallResult } from '../callExternalApi';
import { AdviseActionNeededCondition, AdviseActionNeededReport } from '../../types/advise';

export const fetchAdviseActionNeeded = async (): Promise<CallResult<AdviseActionNeededReport>> =>
  callExternalApi<AdviseActionNeededReport>({
    url: 'api/advise/engagements/action_needed',
    method: 'GET',
    headers: { 'content-type': 'application/json' }
  });

const postEntryAction = (engagementId: string, action: 'snooze' | 'clear', condition: AdviseActionNeededCondition) =>
  callExternalApi<AdviseActionNeededReport>({
    url: `api/advise/engagements/${engagementId}/action_needed/${action}`,
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    data: { condition }
  });

export const snoozeAdviseActionNeeded = async (
  engagementId: string,
  condition: AdviseActionNeededCondition
): Promise<CallResult<AdviseActionNeededReport>> => postEntryAction(engagementId, 'snooze', condition);

export const clearAdviseActionNeeded = async (
  engagementId: string,
  condition: AdviseActionNeededCondition
): Promise<CallResult<AdviseActionNeededReport>> => postEntryAction(engagementId, 'clear', condition);
